import React, {useState, useEffect, Fragment} from 'react'

import CatalogueSidebar from '../../catalogue-sidebar'
import CatalogueContent from '../../catalogue-content'
import Overlooked from '../../overlooked'
import BreadCrumbs from '../../bread-crumbs'

const Catalogue = ({location}) => {
  const
    [categoryId, setCategoryId] = useState(),
    [currentCategory, setCurrentCategory] = useState(''),
    [contentParams, setContentParams] = useState(''),
    [sidebarParams, setSidebarParams] = useState(''),
    [currentPage, setCurrentPage] = useState(1),
    [typeFilter, setTypeFilter] = useState(''),
    [colorFilter, setColorFilter] = useState(''),
    [reasonFilter, setReasonFilter] = useState(''),
    [seasonFilter, setSeasonFilter] = useState(''),
    [minPriceFilter, setMinPriceFilter] = useState(0),
    [maxPriceFilter, setMaxPriceFilter] = useState(0),
    [sizeFilter, setSizeFilter] = useState([]),
    [heelSizeFilter, setHeelSizeFilter] = useState([]),
    [brandFilter, setBrandFilter] = useState(''),
    [discountedFilter, setDiscountedFilter] = useState(false),
    [sortBy, setSortBy] = useState('popularity');

  const filters = {
    typeFilter,
    colorFilter,
    reasonFilter,
    seasonFilter,
    minPriceFilter,
    maxPriceFilter,
    sizeFilter,
    heelSizeFilter,
    brandFilter,
    discountedFilter
  };

  const updateFilters = {
    typeFilter: setTypeFilter,
    colorFilter: setColorFilter,
    reasonFilter: setReasonFilter,
    seasonFilter: setSeasonFilter,
    minPriceFilter: setMinPriceFilter,
    maxPriceFilter: setMaxPriceFilter,
    sizeFilter: setSizeFilter,
    heelSizeFilter: setHeelSizeFilter,
    brandFilter: setBrandFilter,
    discountedFilter: setDiscountedFilter
  };

  const initFilters = () => {
    setTypeFilter('');
    setColorFilter('');
    setReasonFilter('');
    setSeasonFilter('');
    setMinPriceFilter(0);
    setMaxPriceFilter(0);
    setSizeFilter([]);
    setHeelSizeFilter([]);
    setBrandFilter('');
    setDiscountedFilter(false);
  };

  let
    category,
    filter,
    search;

  if (location.state) {
    category = location.state.category;
    filter = location.state.filter;
  }

  if (location.search) {
    search = location.search;
  }

  function composeParams(filter, title) {
    return filter.reduce((params, item) => {
      return params + `&${title}[]=${item}`
    }, '');
  }

  const mapStateToParams = () => {
    const params = [
      categoryId ? `&categoryId=${categoryId}` : '',
      typeFilter ? `&type=${encodeURIComponent(typeFilter)}` : '',
      colorFilter ? `&color=${encodeURIComponent(colorFilter)}` : '',
      reasonFilter ? `&reason=${encodeURIComponent(reasonFilter)}` : '',
      seasonFilter ? `&season=${encodeURIComponent(seasonFilter)}` : '',
      minPriceFilter && minPriceFilter !== 0 ? `&minPrice=${minPriceFilter}` : '',
      maxPriceFilter && maxPriceFilter !== 0 ? `&maxPrice=${maxPriceFilter}` : '',
      sizeFilter ? composeParams(sizeFilter, 'size') : '',
      heelSizeFilter ? composeParams(heelSizeFilter, 'heelSize') : '',
      brandFilter ? `&brand=${encodeURIComponent(brandFilter)}` : '',
      discountedFilter ? `&discounted` : '',
      `&sortBy=${sortBy}`
    ];

    return params.join('')
  };

  useEffect(() => {
    if (filter) {
      const {filterName, value} = filter;
      if (value !== filters[filterName]) {
        initFilters();
        updateFilters[filterName](value);
      }
    }
  }, [filter]);

  useEffect(() => {
    if (category) {
      const newCategoryId = category;
      if (newCategoryId !== categoryId) {
        setCategoryId(newCategoryId);
      }
    }
  }, [category]);

  useEffect(() => {
    if (search) {
      setCategoryId(0);
      setSidebarParams(`sortBy=price`);
      setContentParams(`search=${search.substr(1)}`);
    }
  }, [search]);

  useEffect(() => {
    if (categoryId) {
      const params = categoryId ? `categoryId=${categoryId}&sortBy=price` : '';
      setSidebarParams(params);
      setContentParams(`page=1${mapStateToParams()}`);
    }
  }, [categoryId]);

  useEffect(() => {
    setContentParams(`page=1${mapStateToParams()}`);
  }, [
    typeFilter,
    colorFilter,
    reasonFilter,
    seasonFilter,
    minPriceFilter,
    maxPriceFilter,
    sizeFilter,
    heelSizeFilter,
    brandFilter,
    discountedFilter
  ]);

  useEffect(() => {
    setContentParams(`page=${currentPage}${mapStateToParams()}`);
    window.scrollTo(0, 0);
  }, [currentPage, sortBy]);

  return (
    <Fragment>
      <BreadCrumbs path={[{title: currentCategory}]}/>
      <main className="product-catalogue">
        <section className="sidebar">
          <CatalogueSidebar sidebarParams={sidebarParams}
                            filters={filters}
                            updateFilters={updateFilters}
                            initFilters={initFilters}/>
        </section>
        <section className="product-catalogue-content">
          <CatalogueContent params={contentParams}
                            categoryId={categoryId}
                            setCurrentCategory={setCurrentCategory}
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                            sortBy={sortBy}
                            setSortBy={setSortBy}/>
        </section>
      </main>
      <div style={{display: 'inline-block', width: '100%'}}/>
      <section className="product-catalogue__overlooked-slider">
        <Overlooked/>
      </section>
    </Fragment>
  )
};

export default Catalogue
